export default function hourFormat(hour: number) {
  return hour === 1 ? "1 hour" : `${hour} hours`;
}
